/**
 * 灵犀事件埋点 lxBidTracker
 * @param {Object} opts {bid: String | 必传, type: String | 埋点类型,默认'moduleClick', customParam: Object | 业务参数, options: Object | 其它参数}
 */

export const lxBidTracker = (opts = {}) => {
  const { 
    type = 'moduleClick', 
    bid = '', 
    cid = '',
    customParam = {} 
  } = opts;
  const options = {};
  if (cid) {
    options.cid = cid;
  }
  const valLab = {
    custom: {
      ...customParam
    }
  };
  window.LXAnalytics && window.LXAnalytics(type, bid, valLab, options);
};

/**
 * 灵犀页面埋点 lxCidTracker
 * @param {String} path 需要埋点的路由，获取cid
 */
export const lxCidTracker = cid => {
  window.LXAnalytics && window.LXAnalytics('pageView', null, null, cid);
};



// WEBPACK FOOTER //
// ./src/components/util/lxTracker.js